import i18n from '../i18n';

const text = i18n.t('unsaved-changes');

/* eslint-disable-next-line no-confusing-arrow, no-alert */
export default (changed, next) => !changed || confirm(text) ? next() : null;



// WEBPACK FOOTER //
// ./src/services/change-detection.js